import { render, staticRenderFns } from "./DictionaryTeachingEffects.vue?vue&type=template&id=67158016&scoped=true&"
import script from "./DictionaryTeachingEffects.vue?vue&type=script&lang=js&"
export * from "./DictionaryTeachingEffects.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryTeachingEffects.vue?vue&type=style&index=0&id=67158016&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67158016",
  null
  
)

export default component.exports